export const authReducer = (state = { token: '' }) => state;
